import React from "react";
import projectone from "../assets/images/projectone.jpg";

const ProjectOne = () => {
  return (
    <div className="card rounded-0 border-0 shadow-sm mb-5 mb-lg-0">
      <div className="card-img-container position-relative">
        <img className="card-img-top rounded-0 w-100" src={projectone} alt="" />
        <div className="card-img-overlay">
          <div className="project-logo">
            <h4 className=" h-auto text-center">URL Shortner</h4>
          </div>
        </div>

        <a
          className="card-img-overlay-content text-start p-lg-4 text-white"
          href="https://url-shortner-workflow.netlify.app/signin"
          rel="noreferrer"
          target="_blank"
        >
          <h5>URL Shortner</h5>
          <p>
            A MERN Stack Web Application for shortening long urls and it can
            also track number of clicks for each shortened url
          </p>
        </a>
      </div>

      <div className="card-body">
        <h5 className="text-center">
          <a
            href="https://url-shortner-workflow.netlify.app/signin"
            rel="noreferrer"
            className="badge bg-light text-dark"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <i className="bi bi-cursor-fill mx-2" /> URL Shortner
          </a>
        </h5>
        <h5 className="text-center">
          <a
            className="badge bg-light text-dark"
            href=" https://github.com/Krish90s/url-shortner-project"
            style={{ textDecoration: "none" }}
            target="_blank"
          >
            {" "}
            <i className="bi bi-github" /> Project GitHub Link
          </a>
        </h5>
      </div>
      <div className="card-footer border-0 text-center bg-white pb-4">
        <ul className="list-inline mb-0 mx-auto ">
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">React</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">Express</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">Node.js</span>
          </li>
          <li className="list-inline-item">
            <span className="badge bg-secondary badge-pill">MongoDB</span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default ProjectOne;
